<div
  [formGroup]="formGroup"
  class="flex flex-col w-full"
  *transloco="let t">
  <mat-form-field
    appearance="outline"
    class="fuse-mat-dense flex-auto">

    <!-- Label -->
    @if (label) {
      <mat-label>{{ t(label) | capitalize }}</mat-label>
    }

    <!-- Input -->
    <input
      [id]="id"
      matInput
      [autocomplete]="autocomplete"
      [name]="controlName"
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [matAutocomplete]="optionsSelect"
      (focus)="onInputFocus()"
      (blur)="checkOnBlur()">

    <!-- Icon -->
    @if (!loading && addRoute) {
      <mat-icon
        matSuffix
        class="cursor-pointer"
        [class.text-green-600]="isRegister"
        [ngClass]="'icon-size-' + iconSize"
        [svgIcon]="findIcon"
        [matTooltip]="t(findTooltip)"
        matTooltipPosition="above"
      (click)="openNewTab()"></mat-icon>
    }

    <!-- Spinner -->
    @if (loading && addRoute) {
      <mat-spinner
        matSuffix
        diameter="16"
        class="w-10"
      color="primary"></mat-spinner>
    }

    <!-- Autocomplete -->
    <mat-autocomplete
      #optionsSelect="matAutocomplete"
      [displayWith]="displaySelect">
      @for (option of options$ | async; track option) {
        <mat-option
          [value]="option">
          {{ option?.name }}
        </mat-option>
      } @empty {
        <!-- Painel vazio era indistinguível de componente quebrado; `options` só existe após a primeira busca -->
        @if (!loading && options) {
          <mat-option disabled>{{ t('No results found') }}</mat-option>
        }
      }
    </mat-autocomplete>

    <!-- Errors -->
    @if (validateField.hasErrorValidate(formControl, 'required')) {
      <mat-error>{{ t('required-field') }}</mat-error>
    }
    @if (validateField.hasErrorValidate(formControl, 'minlength')) {
      <mat-error>
        {{ t('field must have at least') }}
        {{ validateField.validateLength(formControl, 'minlength') }}
        {{ t('characters') }}
      </mat-error>
    }
    @if (validateField.hasErrorValidate(formControl, 'maxlength')) {
      <mat-error>
        {{ t('field can have a maximum of') }}
        {{ validateField.validateLength(formControl, 'maxlength') }}
        {{ t('characters') }}
      </mat-error>
    }
  </mat-form-field>
</div>
